import { NotificationPlanRule } from 'mbs-ui-shared@models';

export const selectedNotificationPlanRule = (value: NotificationPlanRule): boolean => {
  return (
    hasNotificationPlanRule(value, NotificationPlanRule.Provider) || hasNotificationPlanRule(value, NotificationPlanRule.SpecifiedEmails)
  );
};

export const hasNotificationPlanRule = (value: NotificationPlanRule, checkValue: NotificationPlanRule): boolean => {
  return (value & checkValue) === checkValue;
};
